import { render, staticRenderFns } from "./StructureChamberDetail.vue?vue&type=template&id=6fb973b6&scoped=true&"
import script from "./StructureChamberDetail.vue?vue&type=script&lang=js&"
export * from "./StructureChamberDetail.vue?vue&type=script&lang=js&"
import style0 from "./StructureChamberDetail.vue?vue&type=style&index=0&id=6fb973b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb973b6",
  null
  
)

export default component.exports